import type { Pack, PackCode, UpdatePackInput } from '@bcl/shared';
import { api } from '@/lib/api';

export async function listAllPacks(): Promise<Pack[]> {
  const { data } = await api.get<Pack[]>('/admin/packs');
  return data;
}

export async function updatePack(
  code: PackCode,
  input: UpdatePackInput,
): Promise<Pack> {
  const { data } = await api.patch<Pack>(`/admin/packs/${code}`, input);
  return data;
}
